export default function DashboardWhiteIcon() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 22 22" fill="none">
      <path
        d="M3.4375 10.059C3.4375 9.55311 3.4375 9.30016 3.50253 9.06722C3.56014 8.86088 3.6548 8.66681 3.78188 8.49454C3.92535 8.30006 4.12448 8.14476 4.52276 7.83418L10.4808 3.18789C10.7895 2.94721 10.9438 2.82687 11.1142 2.78061C11.2645 2.7398 11.423 2.7398 11.5733 2.78061C11.7437 2.82687 11.898 2.94721 12.2067 3.18789L18.1647 7.83418C18.563 8.14476 18.7622 8.30006 18.9056 8.49454C19.0327 8.66681 19.1274 8.86088 19.185 9.06722C19.25 9.30016 19.25 9.55311 19.25 10.059V16.4315C19.25 17.418 19.25 17.9113 19.0585 18.2882C18.8901 18.6196 18.6213 18.8891 18.2907 19.058C17.9149 19.25 17.4229 19.25 16.4389 19.25H6.24861C5.26463 19.25 4.77264 19.25 4.39681 19.058C4.06622 18.8891 3.79744 18.6196 3.629 18.2882C3.4375 17.9113 3.4375 17.418 3.4375 16.4315V10.059Z"
        stroke="#EFE8DE"
        stroke-width="1.66667"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M6.875 12.375H8.79018L10.067 10.3125L12.6205 14.4375L13.8973 12.375H15.8125"
        stroke="#EFE8DE"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
}
